var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MovePreferredDateField',_vm._g({},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }